import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { MODULE_NAME } from '../constants/modules';
import { resetCardOffersPath } from '../ducks/homeDuck';

export const useLoadLanguagePack = () => {
  const locale = useSelector(getActiveLocaleSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' }));
    dispatch(resetCardOffersPath);
  }, [locale, dispatch]);
};
